import { useEffect, useState } from 'react'
import { useFirebolt } from '@iq-firebolt/client'

const useIdentityProof = ({ fireboltStep, frontSideRef, uploadedFilesState }) => {
  const { capturedData } = useFirebolt()
  const [modalErrorOpen, setModalErrorOpen] = useState(false)
  const [modalCloseClicked, setModalCloseClicked] = useState(false)
  const [disabledButton, setDisabledButton] = useState(true)
  const [openCamera, setOpenCamera] = useState(false)
    
  useEffect(()=> {
    setDisabledButton(!capturedData.user_photo)
  },[])

  useEffect(() => {
    const hasError = fireboltStep?.remoteErrors.length > 0 || !uploadedFilesState?.[0].user_photo
    setDisabledButton(hasError)
  }, [fireboltStep, capturedData])

  async function handleStepAfterUpload() {
    setDisabledButton(false)
  }

  function handleNext () {
    fireboltStep?.goNextStep({ user_photo: capturedData?.id ? true : false })
  }

  function handleImageErrorModalStatus (errorStatus) {
    setModalErrorOpen(errorStatus)
  }

  function handleImageErrors (imageErrorsFound) {
    if(!modalErrorOpen && !modalCloseClicked) {
      if(modalErrorOpen !== imageErrorsFound?.invalidImage) {
        handleImageErrorModalStatus(imageErrorsFound?.invalidImage)
      }

      if(modalErrorOpen !== imageErrorsFound?.userPhotoNotMatch) {
        handleImageErrorModalStatus(imageErrorsFound?.userPhotoNotMatch)
      }
    }
  }

  function handleCloseModalError () {
    setModalErrorOpen(false)
    setModalCloseClicked(true)
  }

  return {
    disabledButton,
    modalErrorOpen,
    openCamera,
    setOpenCamera,
    handleImageErrors,
    handleCloseModalError,
    handleStepAfterUpload,
    handleNext
  }
}

export default useIdentityProof
